import { RegistryDiscount } from 'src/types/registryDiscount'
import { Calendar, Discount2, ShoppingCartEmpty } from 'baby-design/icons'
import { InfoWithIcon } from '../../Info/InfoWithIcon'

export const SavingsDetail = () => (
  <InfoWithIcon
    emphasizedText="Save on your entire order from the Babylist Shop!"
    icon={<Discount2 />}
  />
)

export const EligibilityWindowDetail = ({
  registryDiscount,
}: {
  registryDiscount: RegistryDiscount
}) => {
  const { eligibilityPreArrivalDays, eligibilityPostArrivalDays } =
    registryDiscount
  return (
    <InfoWithIcon
      emphasizedText={`Start saving ${eligibilityPreArrivalDays} days before & ${eligibilityPostArrivalDays} days after`}
      icon={<Calendar />}
      restOfText={"your baby's arrival date"}
    />
  )
}

export const CartDetail = () => (
  <InfoWithIcon
    emphasizedText="Automatically appears in your cart"
    icon={<ShoppingCartEmpty />}
    restOfText="to use on eligible items"
  />
)

export const UsageDetail = () => (
  <InfoWithIcon
    emphasizedText="Use it again and again"
    icon={<Discount2 />}
    restOfText="on Babylist Shop items"
  />
)
